var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"font-weight-bolder mr-2",class:(_vm.isLoading ? 'spinner spinner-right ' : '') + _vm.colorClass,attrs:{"disabled":_vm.isLoading || _vm.isDisabled},on:{"click":function($event){return _vm.$emit('save')}}},[_c('i',{class:_vm.iconClass}),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }